/* ============================================================
   PRODUCT IMAGE CAROUSEL
   File: assets/product-image-carousel.js
   Load in theme.liquid before </body>:
     <script src="{{ 'product-image-carousel.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  function initCarousel(wrapper) {
    const id     = wrapper.id.replace('pc-carousel-', '');
    const track  = wrapper.querySelector(`#pc-track-${id}`);
    const dots   = wrapper.querySelectorAll('.pc-dot');
    const prev   = wrapper.querySelector('.pc-arrow--prev');
    const next   = wrapper.querySelector('.pc-arrow--next');
    const counter = wrapper.querySelector('.pc-current');

    if (!track) return;

    const slides = track.querySelectorAll('.pc-slide');
    const total  = slides.length;
    let current  = 0;
    let isAnim   = false;

    /* How many slides are visible at current breakpoint */
    function getSlidesPerView() {
      const w = window.innerWidth;
      if (w >= 768) return 3;
      if (w >= 480) return 2;
      return 1;
    }

    /* Max index we can scroll to */
    function getMaxIndex() {
      return Math.max(0, total - getSlidesPerView());
    }

    /* Width of one slide + gap */
    function getSlideStep() {
      const slide = slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 12;
      return slide.offsetWidth + gap;
    }

    function goTo(index) {
      if (isAnim) return;
      const max = getMaxIndex();
      if (index < 0) index = 0;
      if (index > max) index = max;
      current = index;
      isAnim  = true;

      const offset = current * getSlideStep();
      track.style.transform = `translateX(-${offset}px)`;

      /* Active class on visible slides */
      const spv = getSlidesPerView();
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i >= current && i < current + spv);
      });

      /* Dots */
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));

      /* Counter */
      if (counter) counter.textContent = current + 1;

      /* Arrow visibility */
      if (prev) prev.style.opacity = current <= 0 ? '0.3' : '';
      if (next) next.style.opacity = current >= max ? '0.3' : '';

      setTimeout(() => { isAnim = false; }, 450);
    }

    /* Arrows */
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));

    /* Dots */
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    /* Keyboard */
    wrapper.setAttribute('tabindex', '0');
    wrapper.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    /* Touch / Swipe */
    let touchStartX = 0;
    let touchStartY = 0;
    let swiping     = false;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swiping     = false;
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      const dx = Math.abs(e.touches[0].clientX - touchStartX);
      const dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 8) { swiping = true; e.preventDefault(); }
    }, { passive: false });

    track.addEventListener('touchend', (e) => {
      if (!swiping) return;
      const diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) goTo(diff < 0 ? current + 1 : current - 1);
      swiping = false;
    });

    /* Recalculate on resize (breakpoint changes) */
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => goTo(current), 150);
    });

    /* Init */
    goTo(0);
  }

  function bootAll() {
    document.querySelectorAll('.pc-carousel-wrapper').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', bootAll);

})();
